import styled from 'styled-components'

export const Container = styled.h2`
  margin: 0 auto;
  text-align: center;
  .separator{
    margin: 25px auto;
    width: 30px;
    height: 2px;
    background-color: var(--secondaryColor);
  }
`